module.exports = __webpack_public_path__ + "static/media/mc.fe008c57.png";